// src/App.jsx
import React, { useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from 'themes';
import Routes from 'routes/index';
import NavigationScroll from '../layout/NavigationScroll';
import { getToken, decodeToken, isTokenExpired, removeToken, setupAutoRefresh } from '../utils/auth';
import { ThemeProvider, useThemeMode } from '../context/ThemeContext';

const AppContent = () => {
  const { resolvedMode } = useThemeMode();

  useEffect(() => {
    // Jalankan auto refresh untuk memantau token
    setupAutoRefresh();

    const token = getToken(); // Ambil token dari localStorage
    if (isTokenExpired(token)) {
      console.log("Token is expired or not found.");
      removeToken(); // Hapus token jika sudah kedaluwarsa
    } else {
      console.log("Token is valid.");
    }

    // Menghapus token setelah 3 jam (3 jam = 10800000 ms)
    const tokenExpirationTimer = setInterval(() => {
      if (isTokenExpired(getToken())) {
        console.log("Token expired automatically after 3 hours.");
        removeToken(); // Hapus token setelah 3 jam
        clearInterval(tokenExpirationTimer); // Hentikan interval setelah token dihapus
      }
    }, 60000); // Mengecek setiap menit (60000 ms)

    // Membersihkan interval ketika komponen unmount
    return () => clearInterval(tokenExpirationTimer);
  }, []); // Hanya dijalankan sekali saat komponen dimuat

  return (
    <NavigationScroll>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={theme({ navType: 'light', mode: resolvedMode })}>
          <CssBaseline />
          <Routes />
        </MuiThemeProvider>
      </StyledEngineProvider>
    </NavigationScroll>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
};

export default App;
